import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, BORDER_RADIUS, IMAGE_BORDER_RADIUS, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import TextField from "@material-ui/core/TextField";
import {getInitialFiles} from "../../utils/ValueHelper";
import constants from "../../constants";
import FileHelper from "../../utils/FileHelper";
import SingleFilePicker, {
  ACCEPTED_AUDIO_MIMES,
  ACCEPTED_IMAGE_MIMES,
  AUDIO_MAX_SIZE,
  FILE_TYPE_AUDIO,
  FILE_TYPE_IMAGE,
  IMAGE_MAX_SIZE,
  IMAGE_MAX_WIDTH_HEIGHT,
} from "../commons/SingleFilePicker";
import {ColorActivityFormImage, ColorTheme} from "src/styles/Colors";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {ImageIcon, SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";
import {Button} from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import {logDebug} from "src/js/utils/AppLog";

const useStyles = (theme) => ({
  videoPreview: {
    borderRadius: BORDER_RADIUS,
    border: '5px solid '+ ColorTheme,
    marginLeft: 32,
    marginRight: 32,
    // marginBottom: 2 * FIELD_SPACE,
    width: 320,
    height: 640,
    [theme.breakpoints.down('md')]: {
      width: 280,
      height: 560,
    }
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    padding: 8,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    minWidth: 260,
    width: '100%',
    marginBottom: 16
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
  },
  imageCustomisePlaceholderIcon: {
    width: 48,
    height: 48,
    borderRadius: BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageCustomise1: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    marginBottom: 16,
    padding: 4,
  },
});

const OPINION_CONTENT_TYPES = [
  {'id': 5, 'name': <FormattedMessage id='activity.feedbackContentRating'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.feedbackContentText'/>},
  {'id': 4, 'name': <FormattedMessage id='activity.feedbackContentVideo'/>},
  {'id': 2, 'name': <FormattedMessage id='activity.feedbackContentImage'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.feedbackContentAudio'/>},
];

class ManageActivityOpinion extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    this.key = 0;

    this.maxGamePlayAudioDuration = 10*1000;
    this.maxBgAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxGamePlayAudioDuration = activityData.mediaConfigs.maxGamePlayAudioDuration;
      this.maxBgAudioDuration = activityData.mediaConfigs.maxBgAudioDuration;
    }

    this.slotMinValues = 0;
    this.slotMaxValues = 0;
    this.slotMinImages = 0;
    this.slotMaxImages = 0;
    this.slotTotalImages = 0;
    this.maxWinOffersCount = 0;
    if (activityData.activityConfigs) {
      this.slotMinValues = activityData.activityConfigs.slotMinValues;
      this.slotMaxValues = activityData.activityConfigs.slotMaxValues;
      this.slotMinImages = activityData.activityConfigs.slotMinImages;
      this.slotMaxImages = activityData.activityConfigs.slotMaxImages;
      this.maxWinOffersCount = activityData.activityConfigs.maxWinOffersCount;
    }

    logDebug('activity.contentTypes_1', activityData.contentTypes);

    this.state = {
      contentTypes: activityData.contentTypes || [],
      qTitle: activityData.qTitle || '',
      value1Placeholder: activityData.value1Placeholder || '',
      value2Placeholder: activityData.value2Placeholder || '',
      imageUrl1: activityData.imageUrl1,
      imageFiles1: activityData.imageFiles1,
      fileObjsImage1: activityData.fileObjsImage1,
      isImageDeleted1: activityData.isImageDeleted1,
      bgAudioUrl: activityData.bgAudioUrl,
      bgAudioFiles: activityData.bgAudioFiles,
      isBgAudioDeleted: activityData.isBgAudioDeleted,

      showValidationMsg: false,
      reload: false,
    };

    this.initialFiles1 = getInitialFiles(activityData.imageFiles1, activityData.imageUrl1, FILE_TYPE_IMAGE);
    this.bgAudioInitialFiles = getInitialFiles(activityData.bgAudioFiles, activityData.bgAudioUrl, FILE_TYPE_AUDIO);
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      qTitle,
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      isImageDeleted1,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioUrlDeleted,
      contentTypes,
      value1Placeholder,
      value2Placeholder
    } = this.state;

    if (!excludeError) {
      if (activityData.type === constants.activity.types.VISITOR_OPINION) {
        if (this.isTitleIncorrect(qTitle) || !contentTypes || contentTypes.length === 0) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      }
    }

    return {
      qTitle,
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      isImageDeleted1,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioUrlDeleted,
      contentTypes,
      value1Placeholder,
      value2Placeholder
    };
  }

  render() {
    const {
      qTitle,
      contentTypes,
      value1Placeholder,
      value2Placeholder,
      showValidationMsg,
    } = this.state;
    const {app, activities, activityData, classes, isXS, isDrawerHidden} = this.props;

    let contentTypesError = null;
    if (showValidationMsg) {
      if (!contentTypes || contentTypes.length === 0) {
        contentTypesError = <FormattedMessage id={'activity.pickContentType'}/>;
      }
    }

    return (
      <div className={classes.formActivityWide}>
        {/*<SectionHeaderView labelId={'activity.bgAudio'} />*/}
        {/*{this.getBgAudioView(0)}*/}
        {/*<FieldSpace multiplier={2}/>*/}

        {/*<SectionHeaderView labelId={'activity.aboutFeedback'} extraBottomSpace={true}/>*/}

        {!isXS ? <MediaPlaceholder labelId={'activity.aboutImage'} /> : null}
        <div className={isXS ? classes.flexRowNoCenter : classes.viewColumnFullWidthNoCenter1}>
          {this.getImage1PickerView(0)}
          <FieldSpace vertical={isXS}/>

          <TextField
            variant="filled"
            fullWidth
            required
            multiline
            rows={1}
            rowsMax={8}
            size="small"
            type="text"
            id="qTitle"
            name="qTitle"
            label={<FormattedMessage id={'activity.aboutFeedbackPlaceholder'} />}
            InputProps={{disableUnderline: true}}
            inputProps={{maxLength: 200}}
            value={qTitle}
            onChange={this.onChange}
            error={showValidationMsg && this.isTitleIncorrect(qTitle)}
            helperText={showValidationMsg && this.isTitleIncorrect(qTitle) && <FormattedMessage id='generic.validation.required' />}
          />
        </div>
        <FieldSpace multiplier={2}/>

        <SectionHeaderView labelId={'activity.feedbackContents'} subLabelId={'activity.feedbackContentsHint'}/>
        <div className={classes.viewFullWidthWrap} style={{marginBottom: -8}}>
          {OPINION_CONTENT_TYPES.map((item, index) => {
            const isSelected = contentTypes && contentTypes.includes(item.id);
            return (
              <Button
                color={isSelected ? 'primary' : 'secondary'}
                variant={"outlined"}
                onClick={() => {
                  let {value1Placeholder, value2Placeholder} = this.state;
                  if (isSelected) {
                    contentTypes.splice(contentTypes.indexOf(item.id), 1);
                    if (item.id === 5) {
                      value1Placeholder = null;
                      value2Placeholder = null;
                    }
                  } else {
                    contentTypes.push(item.id);
                  }
                  this.updateState({contentTypes: contentTypes, value1Placeholder: value1Placeholder, value2Placeholder: value2Placeholder});
                }}
                style={{marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0, marginBottom: 8}}
                className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
                startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
                {item.name}
              </Button>
            );
          })}
        </div>
        {contentTypesError ? <FormHelperText error>{contentTypesError}</FormHelperText> : null}
        <FieldSpace multiplier={1.5}/>

        {contentTypes && contentTypes.includes(5) ?
          <div className={classes.viewRowFullWidthNoCenter} style={{flexWrap: 'wrap'}}>
            <div className={classes.viewColumnFullWidthNoCenter} style={{minWidth: 120}}>
              <TextField
                variant="filled"
                fullWidth
                size="small"
                type="text"
                id="value1Placeholder"
                name="value1Placeholder"
                label={<FormattedMessage id={'activity.minRatingPlaceholderSmall'} />}
                InputProps={{disableUnderline: true}}
                inputProps={{maxLength: 10}}
                value={value1Placeholder}
                onChange={this.onChange}
                helperText={<FormattedMessage id={'activity.minRatingPlaceholderHint'}/>}
              />
              <FieldSpace />
            </div>

            <FieldSpace vertical={true}/>
            <div className={classes.viewColumnFullWidthNoCenter} style={{minWidth: 120}}>
              <TextField
                variant="filled"
                fullWidth
                size="small"
                type="text"
                id="value2Placeholder"
                name="value2Placeholder"
                label={<FormattedMessage id={'activity.maxRatingPlaceholderSmall'} />}
                InputProps={{disableUnderline: true}}
                inputProps={{maxLength: 10}}
                value={value2Placeholder}
                onChange={this.onChange}
                helperText={<FormattedMessage id={'activity.maxRatingPlaceholderHint'}/>}
              />
              <FieldSpace />
            </div>
          </div>
          : null
        }

        {this.renderSnackBar()}
      </div>
    )
  }

  getBgAudioView() {
    return (
      <div style={{}}>
        <SingleFilePicker
          key={'SFP1'}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_AUDIO_MIMES}
          maxFileSize={AUDIO_MAX_SIZE}
          maxDuration={this.maxBgAudioDuration}
          initialFiles={this.bgAudioInitialFiles}
          onError={this.onErrorFiles}
          onChange={(files) => {
            this.onChangeFiles(files, 'bgAudioUrl');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'bgAudioUrl');
          }}
        />
      </div>
    );
  }

  getImage1PickerView() {
    return (
      <SingleFilePicker
        key={'SFP1'}
        hideDropzoneText={true}
        size={this.props.isXS ? 'xsmall' : 'small'}
        filesLimit={1}
        showPreviewsInDropzone={true}
        acceptedFiles={ACCEPTED_IMAGE_MIMES}
        maxFileSize={IMAGE_MAX_SIZE}
        maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
        aspectRatio={16/9}
        initialFiles={this.initialFiles1}
        onError={this.onErrorFiles}
        onChange={(files) => {
          this.onChangeFiles(files, 'imageUrl1');
        }}
        onDelete={(file) => {
          this.onDeleteFile(file, 'imageUrl1');
        }}
      />
    );
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id) {
    const {
      imageUrl1,
      imageUrl2,
      bgAudioUrl
    } = this.state;

    let eFileUrl = null;
    let keyFileUrl = null;
    let keyFiles = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eFileUrl)) {
          lFileUrl = eFileUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl1,
      imageFiles1,
      imageUrl2,
      imageFiles2,
      bgAudioUrl,
      bgAudioFiles,
    } = this.state;

    let eFileUrl = null;
    let eFiles = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyIsFileDeleted = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      eFiles = imageFiles1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyIsFileDeleted = 'isImageDeleted1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      eFiles = imageFiles2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyIsFileDeleted = 'isImageDeleted2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      eFiles = bgAudioFiles;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
      keyIsFileDeleted = 'isBgAudioDeleted';
    }

    let lFiles = [];
    let lFileUrl = eFileUrl;
    if (eFiles) {
      let index = 0;
      eFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eFileUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles, [keyIsFileDeleted]: true});
  }

  isTitleIncorrect(title) {
    return (!title || title.trim().length === 0);
  }

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'qTitle') {
      value = value.replace("\n", " ");
    }

    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityOpinion.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityOpinion.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityOpinion))
);
